import type { TeaserColor, TrainingsListingItem } from '~/types/academy/baseTraining';
import { buildAcademyTrainingPath } from '~/utils/academy/trainings/buildAcademyTrainingPath';

const COLOR_MAPPING: Record<string, TeaserColor> = {
    'e-learning': 'orange',
    elearning: 'orange',
    'in-person': 'pink',
    präsenz: 'pink',
    'live-webinar': 'blue'
};

export const getTeaserColor = (trainingType: string | null | undefined): TeaserColor => {
    return COLOR_MAPPING[trainingType?.toLocaleLowerCase().trim() ?? ''] ?? 'blue';
};

export const withTeaserColor = (item: TrainingsListingItem) => ({
    ...item,
    color: getTeaserColor(item.trainingType)
});

export const withResolvedCtaUrl = (
    item: TrainingsListingItem,
    localizedPath: (path: string) => string,
    urlSegment: string,
    academyPath: string
) => ({
    ...item,
    ctaUrl:
        item.type === 'course'
            ? buildAcademyTrainingPath(urlSegment, academyPath, item.id)
            : item.ctaUrl
              ? localizedPath(item.ctaUrl)
              : ''
});
